exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notPermission {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  gap: 1rem;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100%; }\n\nspan {\n  font-size: 12px;\n  font: Poppins;\n  color: #607d8b; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/edit-properties/edit-properties.component.scss
// module id = ../../../../../src/app/components/edit-properties/edit-properties.component.scss
// module chunks = main